export default [{
	path: 'webgl',
	component: () => import('../../../views/platform/webgl/home'),
	meta: {
		title: '实验预览'
	},
	children: [{
			path: 'view2020',
			component: () => import('../../../views/platform/webgl/view2020')
		}, {
			path: 'view',
			component: () => import('../../../views/platform/webgl/view')
		},{
			path: 'view3D',
			component: () => import('../../../views/platform/webgl/view3D')
		},
		// 思政
		{
			path: 'szszzg',
			component: () => import('../../../views/platform/webgl/software_template/szszzg')
		},
		// 虚拟养老院
		{
			path: 'VirtualNursingHome',
			component: () => import('../../../views/platform/webgl/software_template/VirtualNursingHome')
		},
		// //中医特色老年康养虚拟实践系统
		// {
		// 	path: 'ChineseMedicineOldage',
		// 	component: () => import('../../../views/platform/webgl/software_template/ChineseMedicineOldage')
		// },
		//老年康复虚拟仿真实训系统
		{
			path: 'GeriatricRehabilitation',
			component: () => import('../../../views/platform/webgl/software_template/GeriatricRehabilitation')
		}
	]
}]